(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
      // Matches the markup, which ships without the hidden class.
      // connectedCallback picks the real starting state. Scrolling down reveals
      // the bar, scrolling up hides it. Flip `show` in handleScroll() to invert.
      this.isHidden = false;
      this.barHeight = 0;
      this.lastScrollY = Math.max(window.scrollY, 0);
      this.scrollThreshold = 5;
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Hidden from JS rather than from the markup: if the theme bundle never
      // runs, the bar stays visible and the body keeps its padding fallback,
      // i.e. the behaviour before this feature existed. The transition is
      // suppressed for this first hide so the bar does not animate away on load.
      this.classList.add('mobile-sticky-bar--no-transition');
      this.measure();
      this.toggle(this.isNearBottom());
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('mobile-sticky-bar--no-transition');
        });
      });
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.documentElement.style.removeProperty('--f-mobile-navbar-offset');
    }

    measure() {
      // offsetHeight is unaffected by the hide transform, and is 0 while the
      // bar is display:none (>= 768px), which zeroes the offset on desktop.
      this.barHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.barHeight + 'px');
      this.syncOffset();
    }

    /* Publishes the height the bar currently occupies so the sticky ATC bar can
       stack on top of it. The body padding-bottom no longer reads this - it is
       reserved at full height regardless of the hide/show state. */
    syncOffset() {
      document.documentElement.style.setProperty(
        '--f-mobile-navbar-offset',
        (this.isHidden ? 0 : this.barHeight) + 'px'
      );
    }

    handleResize() {
      this.measure();
      if (this.isHidden && this.isNearBottom()) this.toggle(true);
    }

    /* The body keeps a constant padding-bottom the height of this bar. That
       strip is only covered while the bar is on screen, so it must stay below
       the fold before the bar is allowed to hide - otherwise scrolling up from
       the end of the page exposes it as an empty gap. */
    isNearBottom() {
      const distanceFromBottom = Math.max(
        document.documentElement.scrollHeight - window.scrollY - window.innerHeight,
        0
      );
      return distanceFromBottom < this.barHeight;
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const scrollY = Math.max(window.scrollY, 0);
        const delta = scrollY - this.lastScrollY;
        if (Math.abs(delta) < this.scrollThreshold) return;
        this.lastScrollY = scrollY;
        const show = delta > 0;
        if (!show && this.isNearBottom()) return;
        this.toggle(show);
      });
    }

    toggle(show) {
      const shouldHide = !show;
      if (this.isHidden === shouldHide) return;
      this.isHidden = shouldHide;
      this.classList.toggle('mobile-sticky-bar--hidden', shouldHide);
      this.syncOffset();
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pat-mens-pdp-zusatz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var letzteKopfId = null;
  function datenDerKarte(karte) {
    var daten = karte.querySelector('[data-tp-mens-kaufdaten]');
    if (!daten) return null;
    try { return JSON.parse(daten.textContent); } catch (error) { return null; }
  }
  function karteAktualisieren(karte, id) {
    var daten = datenDerKarte(karte);
    var variante = daten && daten[String(id)];
    if (!variante) return;
    var auswahl = karte.querySelector('select[name="id"]');
    if (auswahl) auswahl.value = String(id);
    var bild = karte.querySelector('.tp-express__media img');
    if (bild) {
      bild.srcset = variante.srcset;
      bild.src = variante.src;
      bild.alt = variante.alt || '';
    }
    karte.querySelectorAll('a.tp-express__media, a.tp-express__label').forEach(function (link) { link.href = variante.url; });
    var preis = karte.querySelector('.tp-express__price');
    if (preis) preis.textContent = variante.preis;
    var wahl = karte.querySelector('.tp-mens-kaufkasten__wahl');
    if (wahl) wahl.textContent = variante.wahl;
    var lager = karte.querySelector('.tp-express__lager');
    if (lager) lager.textContent = variante.lieferbar ? 'Auf Lager, versandfertig' : 'Zurzeit ausverkauft';
    var knopf = karte.querySelector('button[name="add"]');
    if (knopf) knopf.disabled = !variante.lieferbar;
  }
  function kaufstellenAktualisieren(id) {
    if (!id) return;
    document.querySelectorAll('.tp-mens-kaufkasten').forEach(function (karte) { karteAktualisieren(karte, id); });
  }
  function kopfVariante() {
    var kopf = document.querySelector('product-info[id^="MainProduct"]');
    if (!kopf) return;
    var formular = document.getElementById('product-form-' + kopf.dataset.section);
    var feld = formular && formular.querySelector('[name="id"]');
    if (feld && feld.value !== letzteKopfId) {
      letzteKopfId = feld.value;
      kaufstellenAktualisieren(feld.value);
    }
  }
  document.addEventListener('change', function (event) {
    var ziel = event.target;
    if (!ziel || !ziel.matches) return;
    if (ziel.matches('.tp-mens-kaufkasten select[name="id"]')) {
      kaufstellenAktualisieren(ziel.value);
      return;
    }
    var picker = ziel.closest('product-info[id^="MainProduct"] variant-picker');
    var daten = picker && picker.querySelector('script[data-tp-varianten]');
    if (!daten) return;
    var varianten;
    try { varianten = JSON.parse(daten.textContent); } catch (error) { return; }
    var werte = [];
    picker.querySelectorAll('[data-picker-field="radio"]').forEach(function (feld) {
      var auswahl = feld.querySelector('input[type="radio"]:checked');
      if (auswahl) werte.push(auswahl.value);
    });
    if (!Array.isArray(varianten)) return;
    var passend = varianten.find(function (variante) {
      return Array.isArray(variante.o) && variante.o.length === werte.length && variante.o.every(function (wert, index) { return wert === werte[index]; });
    });
    if (passend) kaufstellenAktualisieren(passend.i);
  });
  function initialisieren() {
    var kopf = document.querySelector('product-info[id^="MainProduct"]');
    if (!kopf || !document.querySelector('.tp-mens-kaufkasten')) return;
    kopfVariante();
    new MutationObserver(kopfVariante).observe(kopf, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialisieren, { once: true });
  else initialisieren();
})();

  } catch(e) { console.error(e); }
})();
})();
